import { Link, useNavigate } from "react-router-dom";
import { Show, SignInButton, SignUpButton, UserButton } from "@clerk/react";
import { useAuth } from "../context/AuthContext";
import { LogOut, User, Trophy, Home, Shield } from "lucide-react";
import ThemeToggle from "./ThemeToggle";
import Logo from "./Logo";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 glass border-b border-[color:var(--border)]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 grid grid-cols-[1fr_auto_1fr] items-center gap-3">
        <nav className="flex items-center justify-start gap-2 md:gap-3 min-w-0">
          <ThemeToggle className="hidden sm:flex" />
          <Link
            to="/leaderboard"
            className="hidden md:flex items-center gap-2 text-sm text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)] transition"
            data-testid="navbar-leaderboard"
          >
            <Trophy size={16} /> Classement
          </Link>
          <Link
            to="/rules"
            className="hidden md:flex items-center gap-2 text-sm text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)] transition"
            data-testid="navbar-rules"
          >
            Règles
          </Link>
        </nav>

        <Link
          to={user ? "/lobby" : "/"}
          className="flex items-center justify-center shrink-0 justify-self-center"
          data-testid="navbar-logo"
        >
          <Logo size="sm" />
        </Link>

        <nav className="flex items-center justify-end gap-2 md:gap-3 min-w-0">
          <Show when="signed-in">
            {user ? (
              <>
                {user.role === "admin" && (
                  <Link
                    to="/admin"
                    className="hidden md:flex items-center gap-2 text-sm text-amber-500 hover:text-amber-400 transition"
                  >
                    <Shield size={16} /> Admin
                  </Link>
                )}
                <Link
                  to="/profile"
                  className="hidden sm:flex items-center gap-2 text-sm text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)] transition"
                  data-testid="navbar-profile"
                >
                  <User size={16} /> Mon compte
                </Link>
                <button
                  onClick={async () => {
                    await logout();
                    navigate("/");
                  }}
                  className="hidden sm:flex px-3 py-2 rounded-md border border-[color:var(--border)] text-sm hover:bg-[color:var(--surface)] transition items-center gap-2"
                  data-testid="navbar-logout"
                >
                  <LogOut size={16} />
                </button>
                <UserButton afterSignOutUrl="/" />
              </>
            ) : (
              <div className="text-xs text-[color:var(--text-secondary)]">Connexion…</div>
            )}
          </Show>
          <Show when="signed-out">
            <SignInButton mode="modal">
              <button type="button" className="px-4 py-2 rounded-md btn-gold text-sm" data-testid="navbar-login">
                Connexion
              </button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button
                type="button"
                className="hidden sm:inline-flex px-3 py-2 rounded-md border border-[color:var(--border)] text-sm hover:bg-[color:var(--surface)] transition"
                data-testid="navbar-signup"
              >
                Inscription
              </button>
            </SignUpButton>
          </Show>
          <Link
            to={user ? "/lobby" : "/"}
            className="md:hidden p-2 rounded-md border border-[color:var(--border)]"
            data-testid="navbar-home"
          >
            <Home size={16} />
          </Link>
        </nav>
      </div>
    </header>
  );
}
